import { Box } from '@material-ui/core';
import { Lender } from '@nemuru-eng/js-api-client';

import { LenderOptions } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/constants/LenderOptions';
import { Font } from '@/components/shared/components/Font';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { AutocompleteSelectFormField } from '@/components/shared/components/NewContextForms/AutocompleteSelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

interface AddPricingSpecInLenderContextFormProps extends FormGridOptions {
  lenders: Lender[];
}

export const AddPricingSpecInLenderContextForm = ({
  lenders,
  fieldVariant,
  fullWidth,
}: AddPricingSpecInLenderContextFormProps) => {
  const { getTextIdTranslation: t } = useTranslation();
  return (
    <Box>
      <Box mb={4}>
        <Font variant="body2" color="textSecondary">
          <Text tId={'ADD_PRICING_SPEC_IN_LENDER_CONTEXT_DESCRIPTION'} />
        </Font>
      </Box>
      <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
        <AutocompleteSelectFormField name={'lenderId'} label={'LENDER'} selectOptions={LenderOptions(lenders, t)} />
        <TextFormField name={'pricingNameInLenderContext'} label={'PRICING_NAME_IN_LENDER_CONTEXT'} />
        <TextFormField name={'pricingVersion'} label={'PRICING_VERSION'} />
      </FormGridContainer>
    </Box>
  );
};
